// role.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService, RolesBootstrapService } from '@card-software/nexus-utilities';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(
    private router: Router,
    private rolesBootstrapService: RolesBootstrapService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean> {
    const requiredRoles = route.data['roles'] as string[];

    // Roles no longer travel in the JWT, so rehydrate them from the cache on every load.
    this.rolesBootstrapService.restoreFromCache();
    if (AuthService.hasAnyRole(requiredRoles)) {
      return true;
    }

    // Nothing cached for this origin yet (first login or cross-domain landing).
    return this.rolesBootstrapService.ensureLoaded().pipe(
      map(() => {
        const hasAccess = AuthService.hasAnyRole(requiredRoles);
        if (!hasAccess) {
          this.router.navigate(['/unauthorized']);
        }
        return hasAccess;
      }),
    );
  }
}
